module.exports = __webpack_public_path__ + "static/media/ISO.4042879b.PNG";